import { render } from "./Fotos.vue?vue&type=template&id=3ca3d0aa&scoped=true"
import script from "./Fotos.vue?vue&type=script&lang=js"
export * from "./Fotos.vue?vue&type=script&lang=js"

import "./Fotos.vue?vue&type=style&index=0&id=3ca3d0aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca3d0aa"]])

export default __exports__